var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13C6.25 13.1989 6.32902 13.3897 6.46967 13.5303C6.61032 13.671 6.80109 13.75 7 13.75C7.19891 13.75 7.38968 13.671 7.53033 13.5303C7.67098 13.3897 7.75 13.1989 7.75 13V7.75H13C13.1989 7.75 13.3897 7.67098 13.5303 7.53033C13.671 7.38968 13.75 7.19891 13.75 7C13.75 6.80109 13.671 6.61032 13.5303 6.46967C13.3897 6.32902 13.1989 6.25 13 6.25H7.75V1C7.75 0.801088 7.67098 0.610322 7.53033 0.46967C7.38968 0.329018 7.19891 0.25 7 0.25C6.80109 0.25 6.61032 0.329018 6.46967 0.46967C6.32902 0.610322 6.25 0.801088 6.25 1V6.25H1C0.801088 6.25 0.610322 6.32902 0.46967 6.46967C0.329018 6.61032 0.25 6.80109 0.25 7C0.25 7.19891 0.329018 7.38968 0.46967 7.53033C0.610322 7.67098 0.801088 7.75 1 7.75H6.25V13Z",
    fill: "#009BD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/plus-blue.122a57b7c9eae9052f2ffc0489049bae.svg";
export { ForwardRef as ReactComponent };